module.exports = __webpack_public_path__ + "static/media/rating-star-empty.b471afcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/rating-star-empty.svg
// module id = 938
// module chunks = 0